export default __webpack_public_path__ + "static/media/90-deg.08219b68.svg";